  // Dropdown toggle
  const dropdowns = document.querySelectorAll('[data-dropdown]');
  dropdowns.forEach(dd => {
    const link = dd.querySelector('.nav-link');
    link.addEventListener('click', (e) => {
      e.preventDefault();
      // close others
      dropdowns.forEach(other => {
        if (other !== dd) other.classList.remove('open');
      });
      dd.classList.toggle('open');
    });
  });

  // Close dropdowns when clicking outside
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-dropdown]')) {
      dropdowns.forEach(dd => dd.classList.remove('open'));
    }
  });

  // Hover open on desktop
  if (window.matchMedia('(hover: hover)').matches) {
    dropdowns.forEach(dd => {
      let timeout;
      dd.addEventListener('mouseenter', () => {
        clearTimeout(timeout);
        dropdowns.forEach(other => {
          if (other !== dd) other.classList.remove('open');
        });
        dd.classList.add('open');
      });
      dd.addEventListener('mouseleave', () => {
        timeout = setTimeout(() => dd.classList.remove('open'), 150);
      });
    });
  }

  // Mobile menu
  function toggleMobileMenu() {
    document.getElementById('mobileMenu').classList.toggle('open');
    document.getElementById('mobileOverlay').classList.toggle('open');
  }

  // Catalog filter drawer (mobile)
  function toggleCatalogFilter() {
    document.getElementById('catalogSidebar').classList.toggle('open');
    document.getElementById('filterOverlay').classList.toggle('open');
    document.body.style.overflow =
      document.getElementById('catalogSidebar').classList.contains('open') ? 'hidden' : '';
  }

  // Catalog: filter group collapse
  document.querySelectorAll('[data-filter-group] .filter-group-title').forEach(title => {
    title.addEventListener('click', () => {
      title.parentElement.classList.toggle('collapsed');
    });
  });

  // Catalog: checkbox row toggle
  document.querySelectorAll('[data-check]').forEach(row => {
    row.addEventListener('click', (e) => {
      e.stopPropagation();
      row.classList.toggle('checked');
    });
  });

  // Catalog: pill toggle (single-select within group)
  document.querySelectorAll('.filter-pills').forEach(group => {
    group.querySelectorAll('.pill').forEach(pill => {
      pill.addEventListener('click', () => {
        group.querySelectorAll('.pill').forEach(p => p.classList.remove('active'));
        pill.classList.add('active');
      });
    });
  });

  // Catalog: color swatch toggle
  document.querySelectorAll('.color-swatches .swatch').forEach(s => {
    s.addEventListener('click', () => {
      document.querySelectorAll('.color-swatches .swatch').forEach(x => x.classList.remove('active'));
      s.classList.add('active');
    });
  });

  // Catalog: pagination active state
  document.querySelectorAll('.pagination .page-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.textContent === '›') return;
      document.querySelectorAll('.pagination .page-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  // Filter chip remove
  document.querySelectorAll('.chip-x').forEach(x => {
    x.addEventListener('click', (e) => {
      e.stopPropagation();
      x.parentElement.remove();
    });
  });

  // Footer accordion (mobile only)
  const footerMobileMQ = window.matchMedia('(max-width: 768px)');
  document.querySelectorAll('.site-footer .footer-col[data-footer-collapse] h4').forEach(title => {
    title.addEventListener('click', () => {
      if (!footerMobileMQ.matches) return;            // desktop: do nothing
      const col = title.parentElement;
      // close other open footer columns for clean accordion behavior
      document.querySelectorAll('.site-footer .footer-col[data-footer-collapse].open').forEach(other => {
        if (other !== col) other.classList.remove('open');
      });
      col.classList.toggle('open');
    });
  });

  // Reset open states when crossing the desktop/mobile breakpoint
  footerMobileMQ.addEventListener('change', () => {
    document.querySelectorAll('.site-footer .footer-col[data-footer-collapse].open')
      .forEach(c => c.classList.remove('open'));
  });
